import React from 'react';
import { CurricularClass122023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass122023 />;
};

export default ExtraCurricularActivitiesPage;
